var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgPhoto = function SvgSvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.748 16.5a2.75 2.75 0 0 1-1.95-.819A2.74 2.74 0 0 1 0 13.724V4.272A2.74 2.74 0 0 1 .799 2.32a2.74 2.74 0 0 1 1.947-.82H16.75a2.75 2.75 0 0 1 1.951.82c.519.525.803 1.22.799 1.956v.974a.75.75 0 0 1-1.5 0v-.978A1.26 1.26 0 0 0 16.746 3H2.75A1.26 1.26 0 0 0 1.5 4.268v9.46A1.26 1.26 0 0 0 2.754 15a.75.75 0 0 1 .746.754.75.75 0 0 1-.75.746zM10.875 14.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 22.5c-.965 0-1.75-.785-1.75-1.75V9.25c0-.965.785-1.75 1.75-1.75h15.25c.965 0 1.75.785 1.75 1.75v11.5c0 .965-.785 1.75-1.75 1.75zM22.113 21l-4.543-5.191a.74.74 0 0 0-.562-.255.75.75 0 0 0-.616.32L12.784 21zM7 9a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3.95l4.215-5.989a2.24 2.24 0 0 1 1.846-.959 2.24 2.24 0 0 1 1.688.768l3.801 4.343V9.25a.25.25 0 0 0-.25-.25z"
  })));
};
export default SvgSvgPhoto;